import React from "react";
import { gaCommonEvent } from "@/src/utils/gtagEvents";
import GlassColor from "@/src/components/ColorSelect/GlassColor";
import stl from "./productDetailsColorSelect.module.scss";
import classNames from "classnames";
import ProductDetailsColorSelectClient from "./ProductDetailsColorSelectClient";
import ColorTitleTextClient from "./ColorTitleTextClient";
import { useTranslation } from "@/src/i18n/client";
import GetVatText from "@/src/components/GetVatText";
import SizeChart from "./SizeChart";
import { IProductDetailsCommonProps } from "@/src/productDetails/interface";
interface IProps extends IProductDetailsCommonProps {
    hideSize?: boolean;
    isUkUser: boolean;
}

const ProductDetailsColorSelect: React.FC<IProps> =  (props) => {
    const {
        language,
        productDetail,
        activeObj,
        colorList,
        isUkUser,
        hideSize = false,
    } = props;
    const { t } = useTranslation('common');
    return (
        <div className={stl["color-container"]}>
            <div
                className={classNames(
                    stl["product-detail-title"],
                    stl["color-title"],
                )}
            >
                <p className={stl["color-title-text"]}>
                    <span>{t("common:Color")}: </span> <ColorTitleTextClient />
                </p>
                <p
                    style={{
                        float: "right",
                        color:
                            activeObj.colorUnderMarket ||
                            productDetail.p_under_market ||
                            activeObj.outOfStore
                                ? "#919191"
                                : "#21ac4e",
                    }}
                >
                    {activeObj.colorUnderMarket ||
                    productDetail.p_under_market ||
                    activeObj.outOfStore
                        ? t("productDetail:OUT_OF_STOCK")
                        : t("productDetail:IN_STOCK")}
                </p>
                <p style={{ clear: "both" }} />
            </div>
            <ProductDetailsColorSelectClient>
                {colorList.map((item, index) => (
                    <GlassColor
                        key={index}
                        color_id={item.id}
                        color_name={item.name}
                        scale={1.5}
                    />
                ))}
            </ProductDetailsColorSelectClient>
            {isUkUser && (
                <div style={{ marginBottom: "0.2rem" }}>
                    <GetVatText />
                    <a
                        onClick={() => {
                            gaCommonEvent("GO TO FIRMOO UK");
                        }}
                        target="_blank"
                        href="https://www.firmoo.co.uk/"
                        style={{
                            textDecoration: "underline",
                            fontSize: "0.24rem",
                            marginLeft: "0.2rem",
                        }}
                    >
                        Go to Firmoo UK
                    </a>
                </div>
            )}
            {!hideSize && (
                <div style={{ marginTop: "0.4rem" }}>
                    <SizeChart
                        productDetail={productDetail}
                        isShowSizeGuide={false}
                        language={language}
                    />
                </div>
            )}
        </div>
    );
};

export default ProductDetailsColorSelect;
